import React, { useState, useEffect, useRef ,useContext} from 'react';
import { useNavigate, Outlet} from 'react-router-dom';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import HoverDropdown from '../Components/hoverdropdown';
import Spinner from '../Components/sniper';

import '../Assets/css/scrollbar.css';
import inventory from '../Assets/img/invoice.png';
// import '../Assets/css/topCenterToast.css'

import DefaultImage from "../Assets/img/download.png";
import ProfileImage from "../Assets/img/user.png";
import AgentImage from "../Assets/img/agent.png";
import CompanyImage from "../Assets/img/company.png";
import GroupImage from "../Assets/img/group.png";
import StaffImage from "../Assets/img/staff.png";

import { GlobalContext } from '../GlobalContext';

const Home = () => {
    const navigate = useNavigate();
    const [spinFlag, setSpinFlag] = useState(false);
    const { currentTab, setCurrentTab } = useContext(GlobalContext);
    const { userProfileData, setUserProfileData } = useContext(GlobalContext);
    const { countData, setCountData } = useContext(GlobalContext);
    const { selectedUser, setSelectedUser } = useContext(GlobalContext);

    const token = localStorage.getItem('token');
    const gxinToken = localStorage.getItem('gtoken');

    if(!token){
        navigate('/');
    } 
    let decodedToken = {id:0};
    if(token) {
        decodedToken = jwtDecode(token);
    }
    const userId = decodedToken.userId;
    const userName = decodedToken.name || '';

    useEffect(() => {
        const fetch = async () => {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            await axios.post(`${POCBaseUrl}/users/count`,
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Token: token ,  // Include the token
                    },
                  }
            )
            .then(response => {
                setCountData(response.data.data);
                // console.log('countData',response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
        }

        fetch();

        // setInterval(fetch, 3000);
    }, []);

    // console.log('globalvariable',globalVariable);
    const scrollRef = useRef(null);

    const [logoutDropdownOpen, setLogoutDropdownOpen] = useState(false);

    const toggleLogoutDropdown = () => {
        setLogoutDropdownOpen(!logoutDropdownOpen);
    };

    const [openSidebarDropdown, setOpenSidebarDropdown] = useState(null);

    const toggleSidebarDropdown = (dropdownName) => {
        setOpenSidebarDropdown(openSidebarDropdown === dropdownName ? null : dropdownName);
    };
    const [dynamicButtons, setDynamicButtons] = useState(['User Profile']);

    const deleteButton = (title) => {
        const index = dynamicButtons.indexOf(title);
        if (index !== -1) {
            const updatedButtons = [...dynamicButtons];
            updatedButtons.splice(index, 1);
            setDynamicButtons(updatedButtons);
            const currentButtonsLength = updatedButtons.length;
            // console.log(updatedButtons[currentButtonsLength-1]);
            setCurrentTab(updatedButtons[currentButtonsLength-1]);
        } 
    };

    const createButton = (title) => {
        const index = dynamicButtons.indexOf(title);
        if (index !== -1) {
        } else {
            const updatedButtons = [...dynamicButtons]; 
            updatedButtons.push(title);
            setDynamicButtons(updatedButtons);
        }
        setCurrentTab(title);
    }

    //-------------------scroll part-----------------
    const handleKeyDown = (event) => {
        if (scrollRef.current) {
            switch (event.key) {
                case 'ArrowUp':
                    scrollRef.current.scrollBy(0, -5); // Scroll up
                    break;
                case 'ArrowDown':
                    scrollRef.current.scrollBy(0, 5); // Scroll down
                    break;
                default:
                    break;
            }
        }
    };

    useEffect(() => {
        // Add event listener for keydown
        window.addEventListener('keydown', handleKeyDown);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    //----------------tab event-----------
    // const [currentTab, setCurrentTab] = useState('User Profile'); 
    const selectTab = (title) => {
        // setCurrentTab(title);
        setCurrentTab(title);
        switch (title) {
            case 'User Profile':
                navigate('/userprofile');
                break;
            case 'Agent list':
                navigate('/agentlist');
                break;
            case 'create agent accont':
                navigate('/newagent');
                break;
            case 'Company list':
                navigate('/companylist');
                break;
            case 'Create company':
                navigate('/newcompany');
                break;
            case 'Group list':
                navigate('/grouplist');
                break;
            case 'Create groups':
                navigate('/newgroup');
                break;
            case 'User list':
                navigate('/userlist');
                break;
            case 'Create user':
                navigate('/newuser');
                break;
            case 'Function card record':
                navigate('/functioncardrecord');
                break;
            case 'System annoucement':
                navigate('/systemannoucement');
                break;
            case 'Inventory List':
                navigate('/inventorylist');
                break;
            case 'Invoice':
                navigate('/invoice');
                break;
            case 'Create Product':
                navigate('/newproduct');
                break;
            case 'Manage Products':
                navigate('/manageproduct');
                break;
            case 'Debtors List':
                navigate('/debtorslist');
                break;
            case 'Create Rent':
                navigate('/newrent');
                break;
            case 'Monthly Statement':
                navigate('/managesoa');
                break;
            default:
                navigate('/userprofile');
                break;
        }
    }
    //-----------button list scroll bar-------------
    const [height, setHeight] = useState(47);

    useEffect(() => {
        if(dynamicButtons.length > 7) {
            setHeight(58);
        } else {
            setHeight(47);
        }
    }, [dynamicButtons]);
    //-------refresh----------
    const [refreshKey, setRefreshKey] = useState(0); // Unique key for the component
    const handleRefresh = () => {
        window.location.reload();
        setRefreshKey(prevKey => prevKey + 1); // Increment the key to trigger remount

        toast.success('Refresh successfully', {
          className: 'centered-toast-success',
          bodyClassName: 'centered-body',
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          pauseOnHover: false,
          draggable: true,
        });
      };

      useEffect(() => {
        console.log("Div refreshed!"); // Optional: Do something when the div refreshes
      }, [refreshKey]);

      const handleSelectedUser = () => {
        console.log('selectedUser',selectedUser);
      }

    const [isBatchOpen, setIsBatchOpen] = useState(false);

    const handleMouseEnter = () => {
        setIsBatchOpen(true);
    };

    const handleMouseLeave = () => {
        setIsBatchOpen(false);
    };

    const handleLogOut = () => {
        navigate('/'); 
        localStorage.removeItem('token');
        localStorage.removeItem('userLoggedIn');
        localStorage.removeItem("lastFetchTime");
    }
    

    return (
        <>
            {/* {spinFlag && <Spinner />} */}
            {/* -------Header------- */}
            <div className="bg-[#2776c3] w-full pl-6 pr-4 m-0">
                <div className='flex justify-between p-0 m-0'>
                    <div className='w-[215px] h-[65px] text-[white] text-[25px] whitespace-nowrap flex flex-col justify-center' style={{ color: 'white', fontFamily: 'Liberation Serif' }}>
                        {/* <img className="w-[215px] h-[49px] mt-2 ml-[-14px]"
                            src="https://proxy.poc-global.com/api/img/pc/logo.png" alt="Logo" /> */}
                        Irish Cellular Communications Ltd
                    </div>
                    <div className="flex flex-row justify-center items-center m-0 p-0">
                        {/* <div className="mx-5 my-0 flex items-center" style={{ color: 'white', fontFamily: 'Liberation Serif' }}>
                            <div className="flex items-center space-x-1 text-[14px] m-0 p-0">
                                <span className="font-medium text-[14px]">PTT card:</span>
                                <span className="text-[white] text-[14px] mr-4">{userProfileData.ptt_card || 0}</span>
                                <span className="!mr-5 !ml-5 my-0 text-[14px]">|</span>
                            </div>
                            <div className="flex items-center space-x-1 text-[14px] m-0 p-0">
                                <span className="font-medium text-[14px]">Recording card:</span>
                                <span className="text-[white] text-[14px] mr-4">{userProfileData.recording_care || 0}</span>
                                <span className="!mr-5 !ml-5 my-0 text-[14px]">|</span>
                            </div>
                            <div className="flex items-center space-x-1 text-[14px] m-0 p-0">
                                <span className="font-medium text-[14px]">GPS card:</span>
                                <span className="text-[white] text-[14px] mr-4">{userProfileData.gps_card || 0}</span>
                                <span className="!mr-5 !ml-5 my-0 text-[14px]">|</span>
                            </div>
                            <div className="flex items-center space-x-1 text-[14px] m-0 p-0">
                                <span className="font-medium text-[14px]">SOS card:</span>
                                <span className="text-[white] text-[14px] mr-4">{userProfileData.sos_card || 0}</span>
                                <span className="!mr-5 !ml-5 my-0 text-[14px]">|</span>
                            </div>
                            <div className="flex items-center space-x-1 text-[14px] m-0 p-0">
                                <span className="font-medium text-[14px]">Bounding card:</span>
                                <span className="text-[white] text-[14px] mr-4">{userProfileData.bounding_card || 0}</span>
                                <span className="!mr-5 !ml-5 my-0 text-[14px]">|</span>
                            </div>
                            <div className="flex items-center space-x-1 text-[14px] m-0 p-0">
                                <span className="font-medium text-[14px]">Duplex card:</span>
                                <span className="text-[white] text-[14px] mr-4">{userProfileData.duplex_card || 0}</span>
                                <span className="!mr-5 !ml-5 my-0 text-[14px]">|</span>
                            </div>
                            <div className="flex items-center space-x-1 text-[14px] m-0 p-0">
                                <span className="font-medium text-[14px]">VIP card:</span>
                                <span className="text-[white] text-[14px] mr-4">{userProfileData.vip_card || 0}</span>
                                <span className="!mr-5 !ml-5 my-0 text-[14px]">|</span>
                            </div>
                        </div> */}
                        <div className="relative bg-[white] h-full">
                            <button
                                onClick={toggleLogoutDropdown}
                                className="h-full text-white px-3 py-2 rounded flex items-center"
                            >
                                <img
                                    src={DefaultImage}
                                    alt=""
                                    className="w-[26px] mr-[5px] border-0"
                                />
                                <span className='m-0 p-0 cursor-pointer text-[#2776c3] text-[14px]' style={{ fontFamily: 'Liberation Serif' }}>Hello {userName || ''}</span>
                                {!logoutDropdownOpen ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </button>
                            {logoutDropdownOpen && (
                                <div className="absolute right-0 w-full bg-[gray] shadow-lg rounded flex cursor-pointer">
                                    <div className='flex flex-col justify-center'>
                                        <svg
                                            className="h-6 w-6 flex flex-col justify-center text-[white] focus:outline-none focus:border-0 ml-3"
                                            focusable="false"
                                            
                                            viewBox="0 0 24 24"
                                            data-testid="LogoutIcon"
                                            tabIndex="-1"
                                            title="Logout"
                                            fill='white'
                                        >
                                            <path d="m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z"></path>
                                        </svg>
                                    </div>
                                    <div className="block px-2 py-2 text-[white]" style={{ fontFamily: 'Liberation Serif' }} onClick={handleLogOut}>Logout</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* --------------Body container-------------- */}
            <div className='w-full h-full bg-[#ffffff]'>
                <div className="w-full h-full flex">
                    {/* --------------sidebar-------------- */}
                    <div className="h-screen !w-[240px] bg-[#f0f0f0] text-[#5a5655] border-r border-[#ddd]">
                        <div onClick={() => {createButton('User Profile');navigate('/userprofile')}} className="flex items-center border-b border-[#ddd] h-[47px] w-full pl-5 hover:bg-[#ffffff] cusor-pointer">
                            <img
                                src={ProfileImage}
                                alt=""
                                className="imgcl"
                            />
                            <span className='pl-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>User Profile</span>
                        </div>
                        {/* <div onClick={() => toggleSidebarDropdown('agent')} className="!w-[240px] flex justify-between items-center  border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img
                                    src={AgentImage}
                                    alt=""
                                    className="imgcl"
                                />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>My agent</span>
                                <span className='text-[#2776c3] text-[14px] pl-[10px] pr-[10px]'>{countData.agentCount || 0}</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'agent' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'agent' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('Agent list');navigate('/agentlist')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Agent list</div>
                                <div onClick={() => {createButton('create agent accont');navigate('/newagent')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">create agent accont</div>
                            </div>
                        )} */}
                        <div onClick={() => toggleSidebarDropdown('company')} className="flex justify-between items-center border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img
                                    src={CompanyImage}
                                    alt=""
                                    className="imgcl"
                                />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>My company</span>
                                <span className='text-[#2776c3] text-[14px] pl-[10px] pr-[10px]'>{countData.companyCount || 0}</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'company' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'company' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('Company list');navigate('/companylist')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Company list</div>
                                <div onClick={() => {createButton('Create company');navigate('/newcompany')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Create company</div>
                            </div>
                        )}
                        <div onClick={() => toggleSidebarDropdown('group')} className="flex justify-between items-center border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img
                                    src={GroupImage}
                                    alt=""
                                    className="imgcl"
                                />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>My group</span>
                                <span className='text-[#2776c3] text-[14px] pl-[10px] pr-[10px]'>{countData.groupCount || 0}</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'group' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'group' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('Group list');navigate('/grouplist');}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Group list</div>
                                <div onClick={() => {createButton('Create groups');navigate('/newgroup')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Create groups</div>
                            </div>
                        )}
                        <div onClick={() => toggleSidebarDropdown('user')} className="flex justify-between items-center border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img
                                    src={StaffImage}
                                    alt=""
                                    className="imgcl"
                                />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>My user</span>
                                <span className='text-[#2776c3] text-[14px] pl-[10px] pr-[10px]'>{countData.staffCount || 0}</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'user' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'user' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('User list');navigate('/userlist')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">User list</div>
                                <div onClick={() => {createButton('Create user');navigate('/newuser')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Create user</div>
                            </div>
                        )}
                        {/* <div onClick={() => {createButton('Function card record');navigate('/functioncardrecord')}} className="flex items-center border-b border-[#ddd] h-[47px] w-full pl-5 hover:bg-[#ffffff]">
                            <img
                                src="https://proxy.poc-global.com/api/img/pc/service_icon.png"
                                alt=""
                                className="imgcl"
                            />
                            <span className='pl-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>Function card record</span>
                        </div>
                        <div onClick={() => {createButton('System annoucement');navigate('/systemannoucement')}} className="flex items-center border-b border-[#ddd] h-[47px] w-full pl-5 hover:bg-[#ffffff]">
                            <img
                                src="https://proxy.poc-global.com/api/img/pc/notice_icon.png"
                                alt=""
                                className="imgcl"
                            />
                            <span className='pl-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>System annoucement</span>
                        </div> */}
                        <div onClick={() => toggleSidebarDropdown('inventory')} className="flex justify-between items-center border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img
                                    src={inventory}
                                    alt=""
                                    className="w-[34px]"
                                />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>Invoice & Inventory</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'inventory' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'inventory' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('Invoice');navigate('/invoice')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Invoice</div>
                                <div onClick={() => {createButton('Create Product');navigate('/newproduct')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Create Product</div>
                                <div onClick={() => {createButton('Create Rent');navigate('/newrent')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Create Rent</div>
                                <div onClick={() => {createButton('Manage Products');navigate('/manageproduct')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Manage Products</div>
                                <div onClick={() => {createButton('Debtors List');navigate('/debtorslist')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Debtors List</div>
                                <div onClick={() => {createButton('Monthly Statement');navigate('/managesoa')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Monthly Statement</div>
                                <div onClick={() => {createButton('Inventory List');navigate('/inventorylist')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Inventory List</div>
                            </div>
                        )}

                    </div>
                    {/* --------------content-------------- */}
                    <div className="w-[calc(100%-240px)] h-screen flex-1">
                        {/* ---------button list----------- */}
                        <div className="tab-list-scroll w-full flex justify-between items-center border-b border-[#ddd] hover:bg-[#ffffff]" style={{ height: `${height}px`, transition: 'height 0.3s' }}>
                            <div className="w-[calc(100%-42px)] box-border flex whitespace-nowrap overflow-x-auto" style={{ overflowX: 'auto'}}>
                                {dynamicButtons.map((data, index) => (
                                    <div
                                        onClick={() => selectTab(data)}
                                        key={index} // Use a unique key for each element
                                        className={`flex ${data === currentTab ? 'bg-[#dddddd] text-[#2776c3]' : 'bg-[#eeeeee] text-[#5a5655]'} box-content px-5 border-l border-[white] border-b border-[#ddd] !h-[45px] leading-[45px] whitespace-nowrap cursor-pointer text-[14px]`}
                                    >
                                        <span style={{ fontFamily: 'Liberation Serif' }}>{data}</span>
                                        <div className='flex flex-col justify-center'>
                                            <div onClick={() => deleteButton(data)} className='ml-[10px] hover:bg-[#2776c3] h-6 w-6' >
                                                <svg
                                                    className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                                    focusable="false"
                                                    
                                                    viewBox="0 0 24 24"
                                                    data-testid="CloseIcon"
                                                    tabIndex="-1"
                                                    title="Close"
                                                    fill='white'
                                                >
                                                    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div onClick={handleRefresh} className=" W-[32px] flex flex-row justify-center items-center text-[32px] refreshable-div" key={refreshKey}>
                                <svg
                                    className="h-[32px] w-[32px] focus:outline-none focus:border-0 font-normal leading-none mr-[10px] cursor-pointer"
                                    focusable="false"
                                    
                                    viewBox="0 0 24 24"
                                    data-testid="LoopIcon"
                                    tabIndex="-1"
                                    title="Loop"
                                    fill='#5a5655'
                                >
                                    <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z" />
                                </svg>
                            </div>
                        </div>
                        {/* --------------tab--------------------- */}
                        {(currentTab === 'User Profile' || currentTab === 'create agent accont' || currentTab === 'Modify agent information' || currentTab === 'Create company' || currentTab === 'Edit company information' 
                               || currentTab === 'Create groups' || currentTab === 'Create user' || currentTab === 'Edit group' || currentTab === 'Add users' || currentTab === 'Edit users' || 
                               currentTab === 'Inventory' || currentTab === 'Invoice' || currentTab === 'Create Product' || currentTab === 'Manage Products' || currentTab === 'Edit Products Information'
                                || currentTab === 'Debtors List' || currentTab === 'Inventory List' || currentTab === 'Create Rent') &&
                            (<div className='h-full'>
                                <div className="h-[calc(100%-116px)] p-2.5 pb-1.5 overflow-auto" ref={scrollRef} style={{scrollbarWidth: 'none'}}>
                                    <div className="h-[42px] border-b border-gray-300">
                                        <span className="inline-block h-[42px] leading-[41px] px-5 text-[15px] text-gray-600 border border-gray-300 border-b-[white] rounded-tl-[5px] rounded-tr-[5px] bg-white" style={{ fontFamily: 'Liberation Serif' }}>
                                            {currentTab}
                                        </span>
                                    </div>
                                    {/* ----------------tab content--------------- */}
                                    {/* {currentTab === 'User Profile' &&  <UserProfile />}
                                    {currentTab === 'create agent accont' &&  <CreateAgentAccount />}
                                    {currentTab === 'Create company' &&  <CreateCompany />}
                                    {currentTab === 'Create groups' &&  <CreateGroup />}
                                    {currentTab === 'Create user' &&  <CreateUser />} */}
                                    <Outlet/>
                                </div>
                            </div>
                        )}
                        {(currentTab === 'Agent list' || currentTab === 'Company list' || currentTab === 'Group list' || currentTab === 'User list' 
                        || currentTab === 'Function card record' || currentTab === 'System annoucement' || currentTab === 'User management' || currentTab === 'Monthly Statement') &&
                            (<div className='h-full'>
                                <div className="h-[calc(100%-116px)] p-2.5 pb-1.5">
                                    <div className="h-[42px] border-b border-gray-300 flex">
                                        <span className="inline-block h-[42px] leading-[41px] px-5 text-[15px] text-gray-600 border border-gray-300 border-b-[white] rounded-tl-[5px] rounded-tr-[5px] bg-white" style={{ fontFamily: 'Liberation Serif' }}>
                                            {currentTab}
                                        </span>
                                        {/* {currentTab === 'User list' ? 
                                            <div className='flex-1 flex justify-end text-gray-600 text-[14px]' style={{ fontFamily: 'Liberation Serif' }}>
                                                <div className='w-max'>
                                                    <HoverDropdown title="Operating by batch" trigger="hover"/>
                                                </div>
                                            </div>
                                        :''} */}
                                    </div>
                                    {/* ----------------tab content--------------- */}
                                    {/* {currentTab === 'Agent list' &&  <AgentList />}
                                    {currentTab === 'Company list' &&  <CompanyList />}
                                    {currentTab === 'Group list' &&  <GroupList />}
                                    {currentTab === 'User list' &&  <UserList />}
                                    {currentTab === 'Function card record' &&  <FunctionCardRecord />}
                                    {currentTab === 'System annoucement' &&  <SystemAnnoucement />} */}
                                    <Outlet/>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;